import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c543609"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "area-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "資料詳細", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "トップページに戻る", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "content has-background-contents shadow" }
const _hoisted_7 = { class: "navigation" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 送信した資料に戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OuterItem = _resolveComponent("OuterItem")!
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/dms/outer'))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/outer')), ["prevent"]), ["space","enter"]))
        }, _hoisted_5, 32)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_OuterItem)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/dms/outer/list'))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/outer/list')), ["prevent"]), ["space","enter"])),
        class: "button-toList"
      }, [
        _createElementVNode("a", null, [
          _createVNode(_component_DssIcon, { icon: 'arrow-left' }),
          _hoisted_8
        ])
      ], 32)
    ])
  ], 64))
}